export default {
    meetingPlanEditor: {
        heading: 'Conversation plan',
        identityHeading: 'Plan header',
        titleLabel: 'Template title',
        objectiveLabel: 'Objective',
        openingStatementHeading: 'Opening statement',
        openingStatementTitleLabel: 'Title',
        openingStatementTextLabel: 'Text',
        agendaHeading: 'Meeting agenda with discussion points',
        addAgendaItem: 'Add a subject',
        topicLabel: 'Conversation type',
        invitationHeading: 'Calendar invitation',
        invitationTextLabel: 'What the invitation says',
        preparationHeading: 'Preparation questions',
        preparationDescription:
            'These questions help your {{managerPluralLabel}} prepare for the meeting so they can be more effective.',
        tipsHeading: 'Tips',
        observationsHeading: 'Things to observe and follow up on',
        conversationTipsHeading: 'Tips for a meaningful conversation',
        preparationEntryLabel: 'Question',
        tipEntryLabel: 'Tip',
        observationEntryLabel: 'What to observe',
        tipTitleLabel: 'Title',
        tipDescriptionLabel: 'Advice',
        addPreparationQuestion: 'Add a question',
        addTip: 'Add a tip',
        addObservation: 'Add a point',
        removeListEntry: 'Remove this line',
        addConversationTip: 'Add guidance',
        removeConversationTip: 'Remove this guidance',
        removeAgendaItem: 'Remove this subject',
        saved: 'Conversation plan saved.',
        loadError: 'This conversation plan could not be loaded. Try again later.',
        notFound: 'Your organization no longer has a plan for this conversation.',
        retry: 'Try again',
        backToTemplates: 'Back to templates',
        discardTitle: 'Discard the changes to this plan?',
        discardMessage: 'What you have just written in this plan will not be saved.',
        discardConfirm: 'Discard changes',
        discardKeepEditing: 'Keep editing',
        validation: {
            titleRequired: 'A title is required',
            titleTooLong: 'This title is too long',
            objectiveRequired: 'An objective is required',
            openingStatementTextRequired: 'An opening statement is required',
            textTooLong: 'This text is too long',
            agendaItemTitleRequired: 'A subject needs a title',
            agendaItemsTooMany: 'An agenda holds at most 20 subjects',
            durationOutOfRange: 'Give a length between 0 and 480 minutes',
            listEntryRequired: 'This line cannot be left empty',
            listTooMany: 'A list holds at most 20 lines',
            tipTitleRequired: 'A piece of guidance needs a title',
        },
    },
    templateTranslation: {
        title: 'Translate Template',
        subtitle: 'Translate questions and their options to make your survey multilingual',
        selectTargetLanguage: 'Select Target Language',
        selectLanguagePlaceholder: 'Select a language...',
        autoTranslate: 'Auto-translate',
        importTranslations: 'Import translations',
        comingSoonTooltip: 'Coming Soon - This feature is not available yet',
        noOtherLanguagesTooltip:
            'No other survey languages available. Add languages in Company Settings to enable translation.',
        helperText:
            'Switch between languages to translate questions and their options into different languages',
        autoTranslateHelperText:
            'Auto-translate fills only empty translation fields. Your existing translations will not be overwritten.',
        evaluationTitle: 'Evaluation Title',
        questionsToTranslate: 'Questions to Translate',
        questionsHelperText:
            'Sub-questions are indented and highlighted in purple. Make sure to translate both the main questions and their related options.',
        ratingScaleLabels: 'Rating Scale Labels:',
        fromLowerLabel: 'From (Lower label)',
        toUpperLabel: 'To (Upper label)',
        optionsLabel: 'Options to translate:',
        optionLabel: 'Option:',
        enterTranslation: 'Enter {{language}} translation...',
        saveTranslations: 'Save Translations',
        questionTitleRequired: 'All question title translations are required.',
        message: {
            saveSuccess: 'Translations saved successfully.',
        },
    },
    questionnaireTranslation: {
        title: 'Translate Questionnaire',
        subtitle: 'Translate questions and their options to make your questionnaire multilingual',
    },
    template: {
        header: {
            manageYourTemplate: 'Manage your templates',
            templateAccesible:
                'Create templates accessible for all {{managerPluralLabel}} within your organization',
        },
        importTemplateText: 'Import an Amélio Template',
        review360: '360 Feedback',
        selfReview: 'Self-Assessment',
        meetingPlans: {
            heading: '{{managerLabelCapitalized}} conversations',
            empty: 'No conversation template yet.',
            error: 'Conversation templates could not be loaded. Try again later.',
            newPlan: {
                title: 'Write a conversation plan',
                description: 'For a type of meeting, beside your plans.',
            },
            newPlanModal: {
                title: 'New conversation plan',
                subtitle: 'You will write its agenda in the next step.',
                topicLabel: 'Type of meeting',
                create: 'Create plan',
            },
            created: 'Conversation plan created.',
            catalog: {
                title: 'Import an Amélio conversation plan',
                subtitle: 'The imported copy joins your plans and is edited like them.',
                agendaCount: '{{count}} subjects',
                agendaCount_one: '{{count}} subject',
                agendaCount_other: '{{count}} subjects',
                agendaHeading: 'Agenda',
                noAgenda: 'This plan has no agenda.',
                empty: 'The Amélio catalogue holds no plan yet.',
                error: 'The Amélio catalogue could not be loaded. Try again later.',
            },
        },
        settings: {
            heading: 'Allow {{managerPluralLabel}} to access Amélio templates.',
            description:
                "If you don't allow {{managerPluralLabel}} to access our templates, they'll only see your organizational templates below and can create custom assessments.",
            updateSuccess: 'Settings updated successfully.',
        },
        importTemplatemodal: {
            import360ReviewTemplate: 'Import 360 Evaluation Template',
            importSelfReviewTemplate: 'Import Self-Assessment Template',
            importManagerReviewTemplate: 'Import an assessment template for {{managerLabel}}',
            importTemplateSubtitle:
                'You may import Amélio templates and edit all questions from the template.',
            previewButton: 'Preview',
        },
        importTemplateQuestionModal: {
            importTemplateButton: 'Import Template',
            questionPreview: 'Questions Preview',
            noQuestions: 'No questions available in this template.',
        },
        managerSkillSelector: {
            title: 'Choose Competencies to Assess',
            description: 'Select the competencies that should be evaluated in this assessment',
            tileDescription: 'Competency assessment questions will be inserted here',
            options: {
                allSkills: {
                    label: 'All competencies',
                    description: 'Assess all available competencies for comprehensive evaluation',
                },
                weakestSkills: {
                    label: 'Weakest competencies',
                    description: 'Focus on competencies that need improvement',
                },
                olderThanSixMonths: {
                    label: '6 Months and Older',
                    description: 'Competencies last evaluated more than 6 months ago',
                },
                doNotAssessSkills: {
                    label: 'Do not assess competencies for this assessment',
                    description:
                        'Focus only on custom questions without competency-based evaluation',
                },
            },
        },
        deleteConfirmMessage: 'Are you sure you want to delete this template?',
        message: {
            createTemplateSuccess: 'Template created successfully.',
            importTemplateSuccess: 'Template imported successfully.',
            activateSuccess: 'Template activated successfully.',
            deactivateSuccess: 'Template deactivated successfully.',
            deleteSuccess: 'Template deleted successfully.',
        },
        error: {
            cannotDeleteLastActiveQuestionWithDoNotAssessSkills: `You can't delete the last active question while "Do not assess competencies" is selected. Activate another question or choose another competency assessment option first`,
            cannotDeactivateLastActiveQuestionWithDoNotAssessSkills: `You can't deactivate the last active question while "Do not assess competencies" is selected. Activate another question or choose another competency assessment option first`,
            cannotSelectDoNotAssessSkillsWithoutActiveQuestion: `Add or activate a question before selecting "Do not assess competencies"`,
        },
    },
};
